import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root"
})
export class ApiBaseUrlInterceptor implements HttpInterceptor {

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const baseUrl = environment.apiBaseUrl;
        if (!baseUrl) {
            return next.handle(request);
        }

        const url = request.url;
        if (/^https?:\/\//i.test(url)) {
            return next.handle(request);
        }

        const path = url.startsWith("/") ? url : `/${url}`;
        if (!path.startsWith("/api/")) {
            return next.handle(request);
        }

        return next.handle(request.clone({ url: `${baseUrl}${path}` }));
    }
}
